// ---- Replace your current react-bootstrap / react-icons / Fuse imports with this block ----
import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill, BsFillPrinterFill } from "react-icons/bs";
import { FaRegFilePdf } from "react-icons/fa"; // if you use a fa6 package change to 'react-icons/fa6' if available
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import ReactDOM from "react-dom";
import Select from "react-select";

import {
  Accordion,
  Spinner,
  Badge,
  ListGroup,
  OverlayTrigger,
  Tooltip,
  Stack,
  FormControl,
  InputGroup,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
  Tabs,
  ButtonGroup,
  Tab,
  FloatingLabel,
} from "react-bootstrap";
// ------------------------------------------------------------------------------------------

export class ProductIndent extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      purchaserequests: [],
      category: [],
      warehouse: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
      suppliers: [],
      prods: [],
      loaded: false,
      ShowCreatedTabRefresh: true,
      ShowSentTabRefresh: false,
      ShowReceivedTabRefresh: false,
      ShowPartiallyReceivedTabRefresh: false,
      ShowCancelledTabRefresh: false,
      ShowRejectedTabRefresh: false,
      ShowCompletedTabRefresh: false,
      status: 0,
      addModalShow: false,
      key: "New",
    };
  }

  GetSuppliers = () => {
    fetch(
      process.env.REACT_APP_API +
        "Supplier/GetSuppliers/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status !== 400) {
          this.setState({ suppliers: data }, () => {
            this.setState({ reload: false }, () =>
              this.setState({ reload: true })
            );
          });
        }
      })
      .catch((error) => console.error("There was an error!", error));
  };

  GetCategories = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetMainCategory/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status !== 400) {
          this.setState({ category: data }, () => {
            this.setState({ reload: false }, () =>
              this.setState({ reload: true })
            );
          });
        }
      })
      .catch((error) => console.error("There was an error!", error));
  };

  GetWarehouses = () => {
    fetch(
      process.env.REACT_APP_API +
        "Warehouse/GetRawMaterialWarehouses/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status !== 400) {
          this.setState({ warehouse: data }, () => {
            this.setState({ reload: false }, () =>
              this.setState({ reload: true })
            );
          });
        }
      })
      .catch((error) => console.error("There was an error!", error));
  };

  GetAllProducts = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetProducts/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status !== 400) {
          this.setState({ prods: data }, () => {
            this.setState({ reload: false }, () =>
              this.setState({ reload: true })
            );
          });
        }
      })
      .catch((error) => console.error("There was an error!", error));
  };

  GetPurchaseRequest = () => {
    fetch(
      process.env.REACT_APP_API +
        "ProductPurchase/GetPurchaseRequest/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status !== 400) {
          this.setState({ purchaserequests: data }, () => {
            this.setState({ reload: false }, () =>
              this.setState({ reload: true })
            );
          });
        }
      })
      .catch((error) => console.error("There was an error!", error));
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnSaved = () => {
    this.OnRefreshButtonClick();
  };
  OnDeleted = () => {
    this.OnRefreshButtonClick();
  };

  OnRefreshButtonClick = () => {
    this.setState({ purchaserequests: [] }, () => {
      this.GetPurchaseRequest();
    });
  };

  ShowMessagBox = (title, message) => {
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  };

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };

  ShowSelectedTab = (k) => {
    this.setState({
      ShowCreatedTabRefresh: false,
      ShowSentTabRefresh: false,
      ShowReceivedTabRefresh: false,
      ShowPartiallyReceivedTabRefresh: false,
      ShowCancelledTabRefresh: false,
      ShowRejectedTabRefresh: false,
      ShowCompletedTabRefresh: false,
    });

    if (k == "New") this.setState({ ShowCreatedTabRefresh: true });
    if (k == "Sent") this.setState({ ShowSentTabRefresh: true });
    if (k == "Received") this.setState({ ShowReceivedTabRefresh: true });
    if (k == "PartiallyReceived")
      this.setState({ ShowPartiallyReceivedTabRefresh: true });
    if (k == "Cancelled") this.setState({ ShowCancelledTabRefresh: true });
    if (k == "Rejected") this.setState({ ShowRejectedTabRefresh: true });
    if (k == "Completed") this.setState({ ShowCompletedTabRefresh: true });
  };

  componentDidMount = () => {
    if (this.state.loaded == false) {
      this.GetPurchaseRequest();
      this.GetAllProducts();
      this.GetCategories();
      this.GetSuppliers();
      this.GetWarehouses();
      this.state.loaded = true;
    }
    window.scrollTo(0, 0);

    document.addEventListener("keydown", (event) => {
      if (event.key == "F8") {
        this.setState({ addModalShow: true });
      } else if (event.key == "F9") {
        this.OnRefreshButtonClick();
      }
    });
  };

  render() {
    return (
      <>
        <div className="Container-fluid p-0 ">
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
            <h4>
              {" "}
              <b>Product INDENT</b>
            </h4>
            <Navbar.Collapse className="justify-content-end mx-0 ">
              <Nav>
                <ButtonToolbar className="text-end align-middle">
                  <Button
                    size="sm"
                    className="mainthemecolor"
                    onClick={() => this.setState({ addModalShow: true })}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    &nbsp;Add (F8)
                  </Button>
                  &nbsp;
                  <Button
                    className="mainthemecolor"
                    size="sm"
                    onClick={() => this.OnRefreshButtonClick()}
                  >
                    <BiRefresh size="16"></BiRefresh>
                    &nbsp;Refresh (F9)
                  </Button>
                  &nbsp;
                  {/* addModalShow Modal left as-is (you likely have PurchaseRequestAddOrEditModal) */}
                  {this.state.addModalShow === true ? (
                    <PurchaseRequestAddOrEditModal
                      show={this.state.addModalShow}
                      Type="Add"
                      status={this.state.status}
                      onHide={this.addModalClose}
                      suppliers={this.state.suppliers}
                      prods={this.state.prods}
                      category={this.state.category}
                      warehouse={this.state.warehouse}
                    />
                  ) : null}
                </ButtonToolbar>
              </Nav>
            </Navbar.Collapse>
          </Navbar>

          <div className="purposestyle p-2 ">
            {" "}
            <b>Purpose:</b> Use this module to plan Purchase Requirements. Once
            a Purchase Order created, It can share it to Supplier as a PDF file
            or a Printout.
          </div>

          <Tabs
            id="controlled-tab-example"
            activeKey={this.state.key}
            onSelect={(k) => {
              this.setState({ key: k });
              this.ShowSelectedTab(k);
            }}
            className="mb-3 bg-light fw-bold"
            fill
            style={{ fontSize: "16px", color: "yellow" }}
          >
            <Tab
              eventKey="New"
              title={
                "1.New(" +
                this.state.purchaserequests.filter((f) => f.status == 0)
                  .length +
                ")"
              }
            >
              {this.state.ShowCreatedTabRefresh == true ? (
                <ProductPurchaseRequestAccordionTable
                  status="0"
                  purchaserequests={this.state.purchaserequests}
                  category={this.state.category}
                  suppliers={this.state.suppliers}
                  warehouse={this.state.warehouse}
                  prods={this.state.prods}
                  OnDeleted={this.OnDeleted}
                  onHide={this.addModalClose}
                />
              ) : null}
            </Tab>

            <Tab
              eventKey="Sent"
              title={
                "2.Sent to Supplier(" +
                this.state.purchaserequests.filter((f) => f.status == 1)
                  .length +
                ")"
              }
            >
              {this.state.ShowSentTabRefresh == true ? (
                <ProductPurchaseRequestAccordionTable
                  status="1"
                  purchaserequests={this.state.purchaserequests}
                  category={this.state.category}
                  suppliers={this.state.suppliers}
                  warehouse={this.state.warehouse}
                  prods={this.state.prods}
                  OnDeleted={this.OnDeleted}
                  onHide={this.addModalClose}
                />
              ) : null}
            </Tab>

            <Tab
              eventKey="Received"
              title={
                "3.Received(" +
                this.state.purchaserequests.filter((f) => f.status == 2)
                  .length +
                ")"
              }
            >
              {this.state.ShowReceivedTabRefresh == true ? (
                <ProductPurchaseRequestAccordionTable
                  status="2"
                  purchaserequests={this.state.purchaserequests}
                  category={this.state.category}
                  suppliers={this.state.suppliers}
                  warehouse={this.state.warehouse}
                  prods={this.state.prods}
                  OnDeleted={this.OnDeleted}
                  onHide={this.addModalClose}
                />
              ) : null}
            </Tab>

            <Tab
              eventKey="PartiallyReceived"
              title={
                "4.Partially Received(" +
                this.state.purchaserequests.filter((f) => f.status == 3)
                  .length +
                ")"
              }
            >
              {this.state.ShowPartiallyReceivedTabRefresh == true ? (
                <ProductPurchaseRequestAccordionTable
                  status="3"
                  purchaserequests={this.state.purchaserequests}
                  category={this.state.category}
                  suppliers={this.state.suppliers}
                  warehouse={this.state.warehouse}
                  prods={this.state.prods}
                  OnDeleted={this.OnDeleted}
                  onHide={this.addModalClose}
                />
              ) : null}
            </Tab>

            <Tab
              eventKey="Cancelled"
              title={
                "5.Cancelled(" +
                this.state.purchaserequests.filter((f) => f.status == 4)
                  .length +
                ")"
              }
            >
              {this.state.ShowCancelledTabRefresh == true ? (
                <ProductPurchaseRequestAccordionTable
                  status="4"
                  purchaserequests={this.state.purchaserequests}
                  category={this.state.category}
                  suppliers={this.state.suppliers}
                  warehouse={this.state.warehouse}
                  prods={this.state.prods}
                  OnDeleted={this.OnDeleted}
                  onHide={this.addModalClose}
                />
              ) : null}
            </Tab>

            <Tab
              eventKey="Rejected"
              title={
                "6.Rejected(" +
                this.state.purchaserequests.filter((f) => f.status == 5)
                  .length +
                ")"
              }
            >
              {this.state.ShowRejectedTabRefresh == true ? (
                <ProductPurchaseRequestAccordionTable
                  status="5"
                  purchaserequests={this.state.purchaserequests}
                  category={this.state.category}
                  suppliers={this.state.suppliers}
                  warehouse={this.state.warehouse}
                  prods={this.state.prods}
                  OnDeleted={this.OnDeleted}
                  onHide={this.addModalClose}
                />
              ) : null}
            </Tab>
          </Tabs>
        </div>
      </>
    );
  }
}

export class ProductPurchaseRequestAccordionTable extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      itemsByPR: {}, // [prId] -> items array
      loadingByPR: {},
      errorByPR: {},
      totalsByPR: {},
      totalsLoadingByPR: {},
      editModalShow: false,
      editPR: null,
    };
  }

  componentDidMount() {
    this.preloadTotalsForVisibleRows();
  }

  componentDidUpdate(prevProps) {
    // If the set of purchase requests changed (parent refresh), clear cached data
    if (
      prevProps.purchaserequests !== this.props.purchaserequests ||
      prevProps.status !== this.props.status
    ) {
      if (
        this.props.Type === "Edit" &&
        this.props.purchaseRequests &&
        prevProps.purchaseRequests !== this.props.purchaseRequests
      ) {
        this.setState({
          emailSent: this.props.purchaseRequests.emailSent || false,
        });
      }
      // Reset caches for a clean refresh
      this.setState(
        {
          itemsByPR: {},
          loadingByPR: {},
          errorByPR: {},
          totalsByPR: {},
          totalsLoadingByPR: {},
        },
        () => {
          this.preloadTotalsForVisibleRows();
        }
      );
    }
  }

  // filter rows by status prop
  getRowsFromProps = () => {
    return (this.props.purchaserequests || []).filter(
      (f) => String(f.status) === String(this.props.status)
    );
  };

  preloadTotalsForVisibleRows = () => {
    const rows = this.getRowsFromProps();
    if (!rows || !rows.length) return;
    rows.forEach((pr) => {
      if (!pr || !pr.id) return;
      if (this.state.totalsByPR[pr.id] || this.state.totalsLoadingByPR[pr.id])
        return;
      this.fetchTotalsForPR(pr);
    });
  };

  // fetch PR by id, compute totals and cache items
  fetchTotalsForPR = async (pr) => {
    if (!pr?.id) return;
    const prId = pr.id;
    this.setState((s) => ({
      totalsLoadingByPR: { ...s.totalsLoadingByPR, [prId]: true },
    }));
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}ProductPurchase/GetPurchaseRequestById/${prId}`
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      // possible item arrays from backend - be flexible
      const rawItems =
        data?.purchaseRequestItems ||
        data?.PurchaseRequestItems ||
        data?.items ||
        [];

      let totQty = 0,
        totAmount = 0;
      const normalized = rawItems.map((it) => {
        const qty = Number(it.qty ?? it.quantity ?? 0);
        const amount =
          (Number(it.amount ?? it.total ?? it.purchasePrice ?? 0) || 0) * qty;
        totQty += qty;
        totAmount += amount;
        return {
          ...it,
          qty,
          purchasePrice: Number(it.purchasePrice ?? it.rate ?? 0) || 0,
        };
      });

      // update caches (single setState call, keep itemsByPR as object keyed by id)
      this.setState((s) => ({
        totalsByPR: { ...s.totalsByPR, [prId]: { totQty, totAmount } },
        itemsByPR: { ...s.itemsByPR, [prId]: normalized },
        totalsLoadingByPR: { ...s.totalsLoadingByPR, [prId]: false },
      }));
    } catch (err) {
      this.setState((s) => ({
        totalsLoadingByPR: { ...s.totalsLoadingByPR, [prId]: false },
        errorByPR: {
          ...s.errorByPR,
          [prId]: err?.message || "Failed to load totals",
        },
      }));
    }
  };

  // ensure items loaded when accordion opens (no-op if already loaded)
  ensureItemsLoaded = async (pr) => {
    if (!pr?.id) return;
    const prId = pr.id;
    if (this.state.itemsByPR[prId] || this.state.loadingByPR[prId]) return;
    this.setState((s) => ({
      loadingByPR: { ...s.loadingByPR, [prId]: true },
      errorByPR: { ...s.errorByPR, [prId]: null },
    }));
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}ProductPurchase/GetPurchaseRequestById/${prId}`
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const rawItems =
        data?.purchaseRequestItems ||
        data?.PurchaseRequestItems ||
        data?.items ||
        [];
      const items = rawItems.map((it) => ({
        ...it,
        qty: Number(it.qty ?? it.quantity ?? 0),
        qtyReceived: Number(it.qtyReceived ?? 0),
        purchasePrice: Number(it.purchasePrice ?? it.rate ?? 0),
      }));
      this.setState((s) => ({
        itemsByPR: { ...s.itemsByPR, [prId]: items },
        loadingByPR: { ...s.loadingByPR, [prId]: false },
      }));
    } catch (err) {
      this.setState((s) => ({
        loadingByPR: { ...s.loadingByPR, [prId]: false },
        errorByPR: {
          ...s.errorByPR,
          [prId]: err?.message || "Failed to load items",
        },
      }));
    }
  };

  getSupplierNameFromProps = (id) => {
    const sup = (this.props.suppliers || []).find((s) => s.id === id);
    return sup ? sup.name : "";
  };

  getWarehouseNameFromProps = (id) => {
    const wh = (this.props.warehouse || []).find((w) => w.id === id);
    return wh ? wh.name : "";
  };

  getStatusText = (status) =>
    status === 0
      ? "New"
      : status === 1
      ? "Sent to Supplier"
      : status === 2
      ? "Received"
      : status === 3
      ? "Partially Received"
      : status === 4
      ? "Cancelled"
      : status === 5
      ? "Rejected"
      : status === 6
      ? "Completed"
      : "";

  /* ---------------- actions ---------------- */

  openEdit = (purchaseRequest, e) => {
    if (e?.stopPropagation) e.stopPropagation();
    this.setState({ editModalShow: true, editPR: purchaseRequest });
  };

  closeEdit = () => {
    this.setState({ editModalShow: false, editPR: null }, () => {
      if (this.props.onHide) this.props.onHide();
    });
  };

  onDelete = async (purchaseRequest, e) => {
    if (e?.stopPropagation) e.stopPropagation();
    if (!purchaseRequest?.id) return;

    const canDelete =
      !(purchaseRequest.status > 0) ||
      this.context.UserRoles.PRODUCTADMIN === this.context.userData.roleId;
    if (!canDelete) {
      Swal.fire(
        "Restricted",
        "You don't have permission to delete this Purchase Request.",
        "warning"
      );
      return;
    }

    const confirm = await Swal.fire({
      title: "Delete Purchase Request?",
      text: "Warning! This action will delete associated details as well. Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
    });
    if (!confirm.isConfirmed) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}ProductPurchase/DeletePurchaseRequest/${purchaseRequest.id}`,
        { method: "DELETE", headers: { "Content-Type": "application/json" } }
      );
      if (!res.ok) {
        Swal.fire(
          "Not deleted",
          "This PurchaseRequest may be associated with other records. Disassociate first and retry.",
          "error"
        );
        return;
      }
      Swal.fire("Deleted", "Deleted successfully.", "success");
      this.props.OnDeleted && this.props.OnDeleted();
    } catch (err) {
      Swal.fire("Error", "Delete failed: " + err, "error");
    }
  };

  /* ---------------- render helpers ---------------- */

  renderHeaderLine = (pr) => {
    const prId = pr.id;
    const totals = this.state.totalsByPR[prId];
    const totalsLoading = this.state.totalsLoadingByPR[prId];
    const supplier = this.getSupplierNameFromProps(pr.supplierId);
    const wh = this.getWarehouseNameFromProps(pr.warehouseId);
    const statusText = this.getStatusText(pr.status);
    const totQty = totals ? totals.totQty : null;

    return (
      <div className="d-flex flex-wrap w-100 gap-3 align-items-center">
        <div className="fw-semibold">
          {this.context.GetInDateFormat
            ? this.context.GetInDateFormat(new Date(pr.created))
            : new Date(pr.created).toLocaleString()}
        </div>

        <div className="text-muted">PO: {pr.purchaseOrderNo}</div>

        <Badge bg="secondary">{statusText}</Badge>

        <div className="ms-auto d-flex gap-2 align-items-center">
          <small className="text-muted d-none d-md-inline">
            Supplier: <span className="text-dark">{supplier || "-"}</span> • WH:{" "}
            <span className="text-dark">{wh || "-"}</span>
          </small>

          <small className="text-muted d-none d-lg-inline">
            Requested Qty:{" "}
            <span className="text-dark">
              {totalsLoading ? (
                <Spinner animation="border" size="sm" />
              ) : totQty != null ? (
                totQty
              ) : (
                "-"
              )}
            </span>
          </small>

          <ButtonGroup size="sm">
            <OverlayTrigger overlay={<Tooltip>Edit</Tooltip>}>
              <Button
                variant="warning"
                className="mx-2"
                onClick={(e) => this.openEdit(pr, e)}
              >
                Open
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              overlay={
                <Tooltip>Delete (will remove associated details)</Tooltip>
              }
            >
              <Button
                variant="danger"
                className="rounded-circle"
                disabled={
                  pr.status > 0 &&
                  this.context.UserRoles.PRODUCTADMIN !==
                    this.context.userData.roleId
                }
                onClick={(e) => this.onDelete(pr, e)}
              >
                {/* trash icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                  <path
                    fillRule="evenodd"
                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                  />
                </svg>
              </Button>
            </OverlayTrigger>
          </ButtonGroup>
        </div>

        <div className="w-100 small text-muted">
          CreatedBy: <span className="text-dark">{pr.createdBy || "-"}</span>
        </div>
      </div>
    );
  };

  renderItemsTable = (items = []) => {
    if (!items.length) return <div className="text-muted">No items.</div>;

    // Desktop table
    if (window.innerWidth > 900) {
      return (
        <div className="table-responsive">
          <Table hover size="sm" className="mb-2">
            <thead>
              <tr className="text-center">
                <th>#</th>
                <th className="text-start">Item</th>
                <th className="text-center">Requested Qty (A)</th>
                <th className="text-center">Received Qty (B)</th>
                <th className="text-center">Pending(A-B)</th>
                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it, idx) => {
                const qty = Number(it.qty ?? it.quantity ?? 0);
                const qtyReceived = Number(it.qtyReceived ?? 0);
                const diff = qty - qtyReceived;
                const diffClass =
                  diff > 0
                    ? "text-danger"
                    : diff < 0
                    ? "text-warning"
                    : "text-success";

                return (
                  <tr key={it.id || idx} className="text-center">
                    <td>{idx + 1}</td>
                    <td className="text-start" style={{ maxWidth: 280 }}>
                      {it.itemName || it.name || ""}
                    </td>
                    <td className="text-center">{qty.toLocaleString()}</td>
                    <td className="text-center">
                      {qtyReceived > 0 ? qtyReceived.toLocaleString() : "-"}
                    </td>
                    <td className={`text-center ${diffClass}`}>
                      {diff.toLocaleString()}
                    </td>
                    <td>{it.unit || "-"}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      );
    }

    // Mobile
    return (
      <div style={{ overflowY: "auto", maxHeight: "45vh" }}>
        <Table bordered size="sm" className="mb-0">
          <thead className="bg-secondary text-white text-center">
            <tr>
              <td width="5%"></td>
              <td width="45%" className="text-start">
                Item
              </td>
              <td width="15%">Req (A)</td>
              <td width="15%">Rcvd (B)</td>
              <td width="15%">A - B</td>
            </tr>
          </thead>
          <tbody>
            {items.map((it, idx) => {
              const qty = Number(it.qty ?? it.quantity ?? 0);
              const qtyReceived = Number(it.qtyReceived ?? 0);
              const diff = qty - qtyReceived;
              const diffClass =
                diff > 0
                  ? "text-danger"
                  : diff < 0
                  ? "text-warning"
                  : "text-success";

              return (
                <tr key={it.id || idx} className="align-middle text-center">
                  <td>{idx + 1}</td>
                  <td className="text-start">{it.itemName || it.name || ""}</td>
                  <td>{qty.toLocaleString()}</td>
                  <td>
                    {qtyReceived > 0 ? qtyReceived.toLocaleString() : "-"}
                  </td>
                  <td className={diffClass}>{diff.toLocaleString()}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  render() {
    const rows = (this.props.purchaserequests || [])
      .filter((f) => String(f.status) === String(this.props.status))
      .sort((a, b) => (new Date(a.created) > new Date(b.created) ? 1 : -1));

    return (
      <>
        <Accordion
          alwaysOpen
          onSelect={(eventKey) => {
            const pr = rows.find((r) => String(r.id) === String(eventKey));
            if (pr) this.ensureItemsLoaded(pr);
          }}
        >
          {rows.map((pr, idx) => {
            const prId = String(pr.id || idx);
            const items = this.state.itemsByPR[pr.id] || [];
            const loading = Boolean(this.state.loadingByPR[pr.id]);
            const err = this.state.errorByPR[pr.id];

            return (
              <Accordion.Item eventKey={prId} key={prId} className="mb-2">
                <Accordion.Header>{this.renderHeaderLine(pr)}</Accordion.Header>
                <Accordion.Body>
                  {loading ? (
                    <div className="small text-muted">Loading items…</div>
                  ) : err ? (
                    <div className="text-danger small">
                      Failed to load items: {err}
                    </div>
                  ) : (
                    this.renderItemsTable(items)
                  )}
                </Accordion.Body>
              </Accordion.Item>
            );
          })}
        </Accordion>

        {this.state.editModalShow && (
          <PurchaseRequestAddOrEditModal
            show={true}
            status={this.props.status}
            onHide={this.closeEdit}
            purchaseRequest={this.state.editPR}
            suppliers={this.props.suppliers}
            Type="Edit"
            prods={this.props.prods}
            category={this.props.category}
            warehouse={this.props.warehouse}
          />
        )}
      </>
    );
  }
}

export class PurchaseRequestAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      purchaseRequest: { id: undefined, status: -1 },
      currentPurchaseRequestStatus: -1,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      purchaseRequestItems: [],
      showOrderItemModal: false,
      editPurchaseItemRow: 0,
      categoryFilterName: "",
      reload: true,
      sinventoryFiltered: [],
      searchquery: "",
      stockSort: "none",
      stockFilterMin: "",
      stockFilterMax: "",
      showOnlyInStock: false,
      editModalShow: false,
      emailSent: false,

      // --- Sales Order integration state
      showSalesOrderModal: false,
      salesOrders: [],
      selectedSalesOrderId: "",
      selectedSalesOrderItems: [],
      salesOrderLoading: false,
      salesOrderSearchQuery: "",
    };
  }

  // ---------- Helpers ----------
  GetSupplierName = (id) => {
    if (!id && id !== 0) return "";
    const result = this.props.suppliers.filter((supplier) => supplier.id == id);
    if (result && result.length > 0) return result[0].name || "";
    return "";
  };

  GetSupplierDetails = (id) => {
    if (!id) return "";

    const supplier = (this.props.suppliers || []).find(
      (s) => String(s.id) === String(id)
    );

    if (!supplier) return "";

    const {
      companyName,
      name,
      address,
      city,
      state,
      country,
      pinCode,
      mobileNo,
      emailId,
      gstNo,
    } = supplier;

    const supplierName = companyName || name || "";

    let details = `${supplierName}`;

    if (address) details += `, ${address}`;
    if (city) details += `, ${city}`;
    if (state) details += `, ${state}`;
    if (country) details += `, ${country}`;
    if (pinCode) details += ` - ${pinCode}`;

    details += ".";

    if (mobileNo) details += ` Mobile: ${mobileNo}.`;
    if (emailId) details += ` Email: ${emailId}.`;
    if (gstNo) details += ` GST: ${gstNo}.`;

    return details.trim();
  };

  GetWarehouseName = (id) => {
    var result = this.props.warehouse.filter((f) => f.id == id);
    if (result.length > 0) return result[0].name;
    return "";
  };

  GetWarehouseDetails = (id) => {
    var result = this.props.warehouse.filter((f) => f.id == id);
    if (result.length > 0)
      return (
        result[0].name +
        "," +
        result[0].address +
        "," +
        result[0].city +
        "," +
        result[0].state +
        "," +
        result[0].country +
        ". ContactNo:" +
        result[0].contactNo +
        ". EmailId:" +
        result[0].emailId
      );
    return "";
  };

  SendEmailToSupplier = async (toEmail) => {
    try {
      if (!this.state.purchaseRequest || !this.state.purchaseRequest.id) {
        Swal.fire(
          "Info",
          "Save the Purchase Request first before sending email.",
          "info"
        );
        return;
      }

      const html = this.GetPurchaseRequestHTML();
      const payload = {
        subject: `Purchase Request - ${
          this.state.purchaseRequest.purchaseOrderNo || ""
        }`,
        plainTextContent: `Purchase Request ${
          this.state.purchaseRequest.purchaseOrderNo || ""
        }`,
        htmlContent: html,
        purchaseRequestId: this.state.purchaseRequest.id,
        attachPdf: false,
      };

      this.ShowLoadSpinner();

      const res = await fetch(
        `${process.env.REACT_APP_API}Consumers/SendEmailToProductSuppliers/${
          this.context.storeId
        }/${encodeURIComponent(toEmail)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      this.HideLoadSpinner();

      if (res.ok) {
        Swal.fire("Success", "Email sent to supplier successfully.", "success");
        this.setState({ emailSent: true });
      } else {
        const err = await res.json().catch(() => ({}));
        Swal.fire("Error", err.detail || "Failed to send email", "error");
      }
    } catch (ex) {
      this.HideLoadSpinner();
      Swal.fire("Exception", ex.message, "error");
    }
  };

  GetPurchaseRequestHTML = () => {
    const pr = this.state.purchaseRequest || {};
    const items = this.state.purchaseRequestItems || [];

    let createdStr = "";
    if (pr.created) {
      try {
        const d = new Date(pr.created);
        if (!isNaN(d.getTime())) {
          createdStr =
            this.context && this.context.GetInDateFormat
              ? this.context.GetInDateFormat(d)
              : d.toISOString();
        }
      } catch (e) {
        createdStr = "";
      }
    }

    const supplierName = this.GetSupplierName(pr.supplierId) || "";
    const supplierDetails = this.GetSupplierDetails(pr.supplierId) || "";
    const warehouseDetails = this.GetWarehouseDetails(pr.warehouseId) || "";

    let logoUrl = "";
    try {
      if (
        this.context?.store?.storageBlobUrl &&
        this.context?.store?.storageBlobContainerName &&
        this.context?.store?.storageSasToken
      ) {
        logoUrl =
          this.context.store.storageBlobUrl +
          this.context.store.storageBlobContainerName +
          "/images/" +
          this.context.storeSettings.storeLogoFileName +
          this.context.store.storageSasToken;
      }
    } catch (err) {
      console.warn("Logo not available", err);
    }

    let str = `
    <!doctype html>
    <html>
    <head>
      <meta charset='utf-8'>
      <title>Purchase Order - Indent</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          font-size: 12px;
          margin: 20px;
        }
        h2 {
          margin: 6px 0;
        }
        table {
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
          border: 1px dashed #000;
          padding: 6px;
        }
        th {
          background-color: #f3f3f3;
          text-align: left;
        }
      </style>
    </head>
    <body>
  `;

    if (logoUrl) {
      str += `
      <div style="text-align:center;margin-bottom:8px;">
        <img src="${logoUrl}" alt="Store Logo" style="width:80px;height:auto;border-radius:8px;" />
      </div>
    `;
    }

    str += `
    <div style="width: 100%;text-align: center">
      <h2><u>Purchase Order - Indent</u></h2>
    </div>
    <hr/>
  `;

    str += `
    <table style='width:100%'>
      <tr>
        <td style='width:50%'><strong>PO Number:</strong> ${
          pr.purchaseOrderNo || ""
        }</td>
        <td style='width:50%'><strong>Date:</strong> ${createdStr || ""}</td>
      </tr>
    </table>
  `;

    str += `
    <table style='width:100%;margin-top:8px'>
      <tr>
        <td style='width:50%'><strong>From:</strong> ${warehouseDetails}</td>
        <td style='width:50%'><strong>To Supplier:</strong> ${supplierDetails}</td>
          pr.supplierId
        )}</td>
      </tr>
    </table>
  `;

    if (pr.description) {
      str += `
      <p style='margin-top:8px'><strong>Notes:</strong> ${pr.description}</p>
    `;
    }

    str += "<hr/>";

    str += `
    <table style='width:100%;margin-top:8px;border-collapse:collapse;border:1px dashed #000;text-align:left'>
      <thead>
        <tr>
          <th style='width:5%'>#</th>
          <th style='width:55%'>Item Name</th>
          <th style='width:20%;text-align:center'>Required</th>
          <th style='width:20%;text-align:center'>Unit</th>
        </tr>
      </thead>
      <tbody>
  `;

    items.forEach((item, i) => {
      str += `
      <tr>
        <td style='text-align:center;'>${i + 1}</td>
        <td>${item.itemName || ""}</td>
        <td style='text-align:center;'>${item.qty != null ? item.qty : ""}</td>
        <td style='text-align:center;'>${item.unit || ""}</td>
      </tr>
    `;
    });

    str += `
      </tbody>
    </table>
    </body>
    </html>
  `;

    return str;
  };

  PrintMe = () => {
    var printWindow = window.open("", "_blank");
    printWindow.document.write(this.GetPurchaseRequestHTML());
    printWindow.document.close();
    this.onPrintFinished(printWindow.print(), printWindow);
  };

  onPrintFinished = (status, printWindow) => {
    var osvar = this.getOS();
    if (osvar == "Windows") printWindow.close();
  };

  getOS = () => {
    var uA = navigator.userAgent || navigator.vendor || window.opera;
    if (
      (/iPad|iPhone|iPod/.test(uA) && !window.MSStream) ||
      (uA.includes("Mac") && "ontouchend" in document)
    )
      return "iOS";
    var i,
      os = ["Windows", "Android", "Unix", "Mac", "Linux", "BlackBerry"];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], "i").test(uA)) return os[i];
  };

  getMainCategoryId = (subCategoryId) => {
    var mainCategoryId = "";
    return this.context.subCategories
      .filter((e) => e.id === subCategoryId)
      .map((t) => (mainCategoryId = t.mainCategoryId));
    return mainCategoryId;
  };

  // ---------- Search / Filter ----------
  OnCategoryChanged = (e) => {
    const category = e.target.value || "";
    // compute filtered inventory immediately so UI updates reliably
    const base = Array.isArray(this.props.prods) ? this.props.prods : [];
    const filtered = base.filter((p) => {
      if (!category) return true;
      // normalize to strings to avoid type mismatch (number, GUID, etc)
      return this.getMainCategoryId(p.subCategoryId) == category;
    });

    this.setState({ sinventoryFiltered: [] }, () => {
      this.setState({ reload: false });
      this.setState(
        {
          categoryFilterName: category,
          sinventoryFiltered: filtered,
        },
        () => {
          this.setState({ reload: true });
        }
      );
    });
  };

  onSearchChange = (query) => {
    this.setState({ reload: false, searchquery: query });
    if (!query) {
      this.setState({ sinventoryFiltered: this.props.prods }, () => {
        this.setState({ reload: true });
      });
      return;
    }
    const fuse = new Fuse(this.props.prods, {
      keys: ["name"],
      threshold: 0.6,
      ignoreLocation: true,
      findAllMatches: true,
      includeMatches: true,
      distance: 120,
    });
    const result = fuse.search(query);
    const finalResult = [];
    if (result.length) {
      result.forEach((item) => {
        finalResult.push(item.item);
      });
      this.setState({ sinventoryFiltered: finalResult.slice(0, 25) }, () => {
        this.setState({ reload: true });
      });
    } else {
      this.setState({ sinventoryFiltered: [] });
    }
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };

  ShowMessagBox = (title, message) => {
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };

  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  GetPurchaseRequestById = (Id) => {
    fetch(
      process.env.REACT_APP_API + "ProductPurchase/GetPurchaseRequestById/" + Id
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ purchaseRequest: data }, () => {
            this.setState({
              purchaseRequestItems: data.purchaseRequestItems,
              emailSent: data.emailSent || false,
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  // ---------- Validation helper ----------
  canMarkRequestAsReceived = (purchaseRequest, items) => {
    const REQ_STATUS_RECEIVED = 2;

    if (!purchaseRequest) return { ok: true };

    if (Number(purchaseRequest.status) !== REQ_STATUS_RECEIVED) {
      return { ok: true };
    }

    const invalidItems = (items || []).filter(
      (it) => Number(it.receivedStatus || 0) !== 1
    );
    if (invalidItems.length > 0) {
      return {
        ok: false,
        message:
          "Cannot mark this Purchase Request as 'Received' because one or more items are not marked as Received. Please mark all items as Received before changing the request status.",
      };
    }

    return { ok: true };
  };

  AddOrUpdatePurchaseRequestInDB = (print) => {
    if (this.state.purchaseRequestItems.length == 0) {
      Swal.fire({
        title: "Information!",
        text: "Add required items to the Purchase Order and try again!",
        timer: 3000,
      });
      return;
    }

    const validation = this.canMarkRequestAsReceived(
      this.state.purchaseRequest,
      this.state.purchaseRequestItems
    );
    if (!validation.ok) {
      Swal.fire({
        icon: "warning",
        title: "Validation",
        text: validation.message,
      });
      return;
    }

    this.ShowLoadSpinner();

    if (this.state.purchaseRequest.status == -1) {
      this.state.purchaseRequest.status = 0;
      this.state.purchaseRequest.createdBy = this.context.userData.emailId;
    }

    var tmpPurchaseRequest = this.state.purchaseRequest;
    tmpPurchaseRequest.storeId = this.context.storeId;
    tmpPurchaseRequest.emailSent = this.state.emailSent;

    tmpPurchaseRequest.purchaseRequestItems = this.state.purchaseRequestItems;

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpPurchaseRequest),
    };

    fetch(
      process.env.REACT_APP_API + "ProductPurchase/AddOrUpdatePurchaseReuest/",
      requestOptions
    )
      .then((res) => {
        this.HideLoadSpinner();
        if (res.status == 200) {
          if (print == true) this.PrintMe();
          this.props.onHide();
          return;
        }

        Swal.fire({
          title: "Information!",
          text: "This PurchaseRequest is already exist. try again!",
          timer: 3000,
        });
        return;
      })
      .catch((error) => {
        this.HideLoadSpinner();
        Swal.fire({
          title: "Exception!",
          text: "Received an Exception. Try after sometime !!" + error,
          timer: 3000,
        });
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.AddOrUpdatePurchaseRequestInDB();
  };

  // ---------- Items logic ----------
  UpdatePurchaseItem = (item, index) => {
    this.state.purchaseRequestItems[index].itemName = item.itemName;
    this.state.purchaseRequestItems[index].qty = item.qty;
    this.state.purchaseRequestItems[index].weight = item.weight;
    this.state.purchaseRequestItems[index].unit = item.unit;
    this.state.purchaseRequestItems[index].purchasePrice = item.purchasePrice;

    this.setState({
      purchaseRequestItems: this.state.purchaseRequestItems,
      editModalShow: false,
    });
  };

  AddPurchaseItem = (item) => {
    this.setState(
      {
        purchaseRequestItems: [
          ...this.state.purchaseRequestItems,
          {
            itemName: item.name,
            qty: 1,
            weight: item.weight,
            unit: item.unit,
            purchasePrice: item.mrp,
            receivedStatus: 0,
          },
        ],
      },
      () => {
        this.onHideOrderItemModal();
      }
    );
  };

  AddNewPurchaseItem = () => {
    this.setState(
      {
        purchaseRequestItems: [
          ...this.state.purchaseRequestItems,
          {
            itemName: "",
            qty: 1,
            qtyReceived: 0,
            weight: 1,
            unit: this.context.storeSettings.defaultUnit,
            purchasePrice: 0,
            receivedStatus: 0,
          },
        ],
      },
      () => {
        this.onHideOrderItemModal();
      }
    );
  };

  handleRemoveClick = (indexno) => {
    const list = [...this.state.purchaseRequestItems];
    list.splice(indexno, 1);
    this.setState({ purchaseRequestItems: list });
  };

  onHideOrderItemModal = () => {
    this.setState({ showOrderItemModal: false, editModalShow: false });
  };

  handleAddItems = (e) => {
    this.setState({ showOrderItemModal: true });
  };

  OnEditButtonClick = (e, i) => {
    this.setState({ editPurchaseItemRow: i, editModalShow: true });
  };

  editModalClose = () => {
    this.setState({ editModalShow: false });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "supplierId":
        this.state.purchaseRequest.supplierId = value;
        break;
      case "warehouseId":
        this.state.purchaseRequest.warehouseId = value;
        break;
      case "name":
        this.state.purchaseRequest.name = value;
        break;
      case "status":
        this.state.purchaseRequest.status = value;
        break;
      case "description":
        this.state.purchaseRequest.description = value;
        break;
      case "purchaseOrderNo":
        this.state.purchaseRequest.purchaseOrderNo = value;
        break;
    }
    this.setState({ purchaseRequest: this.state.purchaseRequest });
  };

  handlesInputChange = (e, i) => {
    const { name, value } = e.target;
    switch (name.trim()) {
      case "itemName":
        this.state.purchaseRequestItems[i].itemName = value;
        break;
      case "qty":
        this.state.purchaseRequestItems[i].qty = value;
        break;
      case "weight":
        this.state.purchaseRequestItems[i].weight = value;
        break;
      case "unit":
        this.state.purchaseRequestItems[i].unit = value;
        break;
      case "purchasePrice":
        this.state.purchaseRequestItems[i].purchasePrice = value;
        break;
      case "receivedStatus":
        this.state.purchaseRequestItems[i].receivedStatus = value;
        break;
      case "notes":
        this.state.purchaseRequestItems[i].notes = value;
        break;
    }
    this.setState({
      purchaseRequestItems: this.state.purchaseRequestItems,
    });
  };

  GetPricePerKgOfId = (row) => {
    var result = this.props.prods.filter((f) => f.name == row.itemName);
    if (result.length > 0) {
      var price = result[0].purchasePrice / result[0].weight;
      return price;
    } else {
      return 0;
    }
  };

  GetPriceOfIngredient = (row) => {
    var result = this.props.prods.filter((f) => f.name == row.itemName);
    if (result.length > 0) {
      var perKg = this.GetPricePerKgOfId(row);
      var r = perKg * row.weight;
      return r;
    } else return 0;
  };

  GetTotalEstimation = () => {
    return this.state.purchaseRequestItems.reduce(
      (a, v) => (a = a + (v.purchasePrice || 0) * Number(v.qty || 0)),
      0
    );
  };

  // --- Instk Qty sort / filter handlers ---
  onStockSortChange = (e) => {
    this.setState({ stockSort: e.target.value });
  };
  onStockFilterMinChange = (e) => {
    this.setState({ stockFilterMin: e.target.value });
  };
  onStockFilterMaxChange = (e) => {
    this.setState({ stockFilterMax: e.target.value });
  };
  onShowOnlyInStockToggle = (e) => {
    this.setState({ showOnlyInStock: e.target.checked });
  };

  componentDidMount() {
    this.setState({
      sinventoryFiltered: this.props.prods,
    });

    if (this.props.Type == "Edit" && this.props.purchaseRequest) {
      this.GetPurchaseRequestById(this.props.purchaseRequest.id);
      this.setState({
        currentPurchaseRequestStatus: this.props.purchaseRequest.status,
      });
    }

    if (document.getElementById("name") != null)
      document.getElementById("name").focus();

    document.addEventListener("keydown", (event) => {
      if (event.key == "F8") {
        this.handleAddItems(event);
      }
    });
  }

  // GetSupplierDetails = (id) => {
  //   var r = this.props.suppliers.filter((f) => f.id == id);
  //   if (r.length > 0) {
  //     return r[0].name;
  //   }
  //   return "";
  // };

  // ---------- Sales Order helpers ----------
  OpenSalesOrderModal = async () => {
    this.setState({
      showSalesOrderModal: true,
      salesOrderLoading: true,
      salesOrders: [],
    });
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}SalesOrder/GetSalesOrders/${this.context.storeId}`
      );
      if (!res.ok) {
        console.error("Failed to fetch sales orders");
        this.setState({ salesOrderLoading: false });
        return;
      }
      const data = await res.json();
      this.setState({
        salesOrders: Array.isArray(data) ? data : [],
        salesOrderLoading: false,
      });
    } catch (ex) {
      console.error("Exception fetching sales orders", ex);
      this.setState({ salesOrderLoading: false });
    }
  };

  OnSalesOrderSelected = async (e) => {
    const id = e.target.value;
    this.setState({ selectedSalesOrderId: id, selectedSalesOrderItems: [] });
    if (!id) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}SalesOrder/GetSalesOrderById/${id}`
      );
      if (!res.ok) {
        console.error("Failed to load sales order items");
        return;
      }
      const so = await res.json();
      const items =
        so?.salesOrderItems || so?.SalesOrderItems || so?.salesOrderItems || [];

      const normalized = (items || []).map((it) => ({
        id: it.id,
        itemName: it.itemName || it.ItemName || "",
        qty:
          this.context.store.businessTypeId ==
          this.context.BusinessTypes.STEELTRADERS
            ? it.piecesOrdered ?? 0
            : it.qtyOrdered ?? 0,
        // weight: it.weight ?? it.Weight ?? 1,
        // unit: it.unit ?? it.Unit ?? "",
        // purchasePrice: it.rate ?? it.Rate ?? it.purchasePrice ?? 0,
        notes: it.notes ?? it.Notes ?? "",
      }));

      this.setState({ selectedSalesOrderItems: normalized });
    } catch (ex) {
      console.error("Exception loading sales order", ex);
    }
  };

  // Adds all items from selected Sales Order to the purchaseRequestItems table
  AddSalesOrderItemsToRequest = () => {
    const { selectedSalesOrderItems, purchaseRequestItems } = this.state;
    if (!selectedSalesOrderItems || selectedSalesOrderItems.length === 0) {
      Swal.fire("Info", "No items to add from selected Sales Order.", "info");
      return;
    }

    const existingNames = new Set(
      (purchaseRequestItems || []).map((p) => (p.itemName || "").trim())
    );
    const itemsToAdd = [];

    selectedSalesOrderItems.forEach((it) => {
      const name = (it.itemName || "").trim();
      if (!name) return;
      if (existingNames.has(name)) {
        // skip duplicates; you can change this to merge quantities if desired
        return;
      }

      itemsToAdd.push({
        itemName: name,
        qty: it.qty || 1,
        weight: it.weight ?? 1,
        unit: it.unit || this.context.storeSettings.defaultUnit || "",
        purchasePrice: it.purchasePrice || 0,
        receivedStatus: 0,
        notes: it.notes || "",
      });
    });

    if (itemsToAdd.length === 0) {
      Swal.fire(
        "Info",
        "All items already exist in the Purchase Request.",
        "info"
      );
      return;
    }

    this.setState(
      {
        purchaseRequestItems: [...(purchaseRequestItems || []), ...itemsToAdd],
        showSalesOrderModal: false,
        selectedSalesOrderId: "",
        selectedSalesOrderItems: [],
      },
      () => {
        this.onHideOrderItemModal();
      }
    );
  };

  // ---------- Render helpers ----------
  renderInventorySidebar(inventory) {
    return (
      <div className="p-1">
        <h6>
          <b>Current Stocks</b>
        </h6>
        <div className="mb-2">
          <Stack gap={2}>
            <InputGroup>
              <InputGroup.Text>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
              </InputGroup.Text>
              <FormControl
                type="search"
                placeholder="Search"
                aria-label="Search"
                onChange={(e) => this.onSearchChange(e.target.value)}
              />
            </InputGroup>

            <InputGroup>
              <InputGroup.Text>Category</InputGroup.Text>
              <Form.Select
                value={this.state.categoryFilterName}
                onChange={(e) => this.OnCategoryChanged(e)}
              >
                <option value=""></option>
                {this.props.category.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Stack>
        </div>

        {/* Stock controls */}
        <Row className="mb-2">
          <Col xs={12} className="mb-2">
            <Form.Select
              value={this.state.stockSort}
              onChange={(e) => this.onStockSortChange(e)}
            >
              <option value="none">Sort: Name (A-Z)</option>
              <option value="asc">Sort: InStk Qty ↑</option>
              <option value="desc">Sort: InStk Qty ↓</option>
            </Form.Select>
          </Col>
          <Col xs={6}>
            <Form.Control
              size="sm"
              type="number"
              placeholder="Min Qty"
              value={this.state.stockFilterMin}
              onChange={(e) => this.onStockFilterMinChange(e)}
            />
          </Col>
          <Col xs={6}>
            <Form.Control
              size="sm"
              type="number"
              placeholder="Max Qty"
              value={this.state.stockFilterMax}
              onChange={(e) => this.onStockFilterMaxChange(e)}
            />
          </Col>
          <Col xs={12} className="mt-2">
            <Form.Check
              inline
              type="checkbox"
              label="Only InStock"
              checked={this.state.showOnlyInStock}
              onChange={(e) => this.onShowOnlyInStockToggle(e)}
            />
          </Col>
        </Row>

        <div style={{ maxHeight: "45vh", overflowY: "auto" }}>
          <Table size="sm" className="table-sm mb-0">
            <thead>
              <tr>
                <th className="text-start">Product Name</th>
                <th>InStk</th>
                <th>Unit</th>
                <th>Price</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {inventory.map((prod, i) => (
                <tr key={prod.id || i}>
                  <td className="text-start">{prod.name}</td>
                  <td>{prod.inStockQty}</td>
                  <td>{prod.unit}</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    {Number(prod.mrp).toLocaleString(
                      this.context.storeSettings.defaultLocale,
                      {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1,
                        style: "currency",
                        currency: this.context.storeSettings.defaultCurrency,
                      }
                    )}
                  </td>
                  <td className="text-end">
                    {this.state.purchaseRequestItems &&
                    this.state.purchaseRequestItems.filter(
                      (p) => p.itemName == prod.name
                    ).length > 0 ? (
                      <Button variant="secondary" size="sm" disabled>
                        ADDED
                      </Button>
                    ) : (
                      <Button
                        size="sm"
                        onClick={() => this.AddPurchaseItem(prod)}
                      >
                        Add &gt;&gt;
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }

  renderInventoryAccordion(inventory) {
    return (
      <Accordion defaultActiveKey="0" className="mb-2">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Search / Inventory</Accordion.Header>
          <Accordion.Body>
            {this.renderInventorySidebar(inventory)}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }

  // ---------- Render ----------
  render() {
    let inventory = this.state.sinventoryFiltered
      ? [...this.state.sinventoryFiltered]
      : [...(this.props.prods || [])];

    inventory = inventory.filter((f) => {
      const sel = this.state.categoryFilterName || "";
      if (!sel) return true; // no filter -> keep all

      // try direct categoryId first (some data may have it)
      const productMainCat = f.categoryId
        ? f.categoryId
        : // otherwise map from subCategoryId -> mainCategoryId
          this.getMainCategoryId(f.subCategoryId);

      // normalize to string to avoid number/GUID mismatch
      return String(productMainCat) === String(sel);
    });

    if (this.state.showOnlyInStock) {
      inventory = inventory.filter((p) => Number(p.inStockQty) > 0);
    }
    if (this.state.stockFilterMin !== "") {
      const min = Number(this.state.stockFilterMin);
      if (!Number.isNaN(min))
        inventory = inventory.filter((p) => Number(p.inStockQty) >= min);
    }
    if (this.state.stockFilterMax !== "") {
      const max = Number(this.state.stockFilterMax);
      if (!Number.isNaN(max))
        inventory = inventory.filter((p) => Number(p.inStockQty) <= max);
    }

    if (this.state.stockSort === "asc") {
      inventory.sort((a, b) => Number(a.inStockQty) - Number(b.inStockQty));
    } else if (this.state.stockSort === "desc") {
      inventory.sort((a, b) => Number(b.inStockQty) - Number(a.inStockQty));
    } else {
      inventory.sort((a, b) =>
        a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1
      );
    }

    return (
      <Modal
        {...this.props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        fullscreen="sm-down"
        style={{ fontFamily: "sans-serif", fontSize: "12px" }}
        backdrop="static"
        keyboard={false}
        dialogClassName="purchaserequest-modal"
      >
        {this.state.msgboxOpen && (
          <MessageBox
            open={this.state.msgboxOpen}
            title={this.state.msgboxTitle}
            message={this.state.msgboxMessage}
            callback={this.CloseMessagBoxCallback}
          />
        )}
        {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}

        <Form onSubmit={this.handleSubmit}>
          <Modal.Header closeButton className="bg-warning p-1 m-0">
            <Modal.Title id="contained-modal-title-vcenter">
              {this.props.Type == "Edit"
                ? "Edit Purchase Request"
                : "Add Purchase Request"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-0">
            <Row className="m-0">
              {this.props.status == 0 ? (
                <Col
                  md={4}
                  xs={12}
                  className="d-none d-md-block border-end"
                  style={{ paddingLeft: 0, paddingRight: 0 }}
                >
                  {this.renderInventorySidebar(inventory)}
                </Col>
              ) : null}

              <Col md={this.props.status == 0 ? 8 : 12} className="p-2">
                {this.props.status == 0 && (
                  <div className="d-block d-md-none">
                    {this.renderInventoryAccordion(inventory)}
                  </div>
                )}

                <h5>
                  <b>Product Purchases INDENT</b>
                </h5>

                <Row className="g-2 align-items-center">
                  {this.state.purchaseRequest.purchaseOrderNo && (
                    <Col xs={12} md={3}>
                      <FloatingLabel label="PO Number">
                        <Form.Control
                          type="text"
                          id="name"
                          name="purchaseOrderNo"
                          value={this.state.purchaseRequest.purchaseOrderNo}
                          required
                          disabled
                        />
                      </FloatingLabel>
                    </Col>
                  )}

                  <Col xs={12} md={3}>
                    <FloatingLabel label="Supplier *">
                      <Form.Select
                        size="sm"
                        id="name"
                        name="supplierId"
                        value={this.state.purchaseRequest.supplierId || ""}
                        required
                        disabled={this.props.status != 0}
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value=""></option>
                        {this.props.suppliers
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((supplier) => (
                            <option key={supplier.id} value={supplier.id}>
                              {supplier.name}
                            </option>
                          ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>

                  <Col xs={12} md={2}>
                    <FloatingLabel label="Warehouse *">
                      <Form.Select
                        name="warehouseId"
                        value={this.state.purchaseRequest.warehouseId || ""}
                        required
                        disabled={this.props.status != 0}
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value={""}></option>
                        {this.props.warehouse.map((m) => (
                          <option key={m.id} value={m.id}>
                            {m.name}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>

                  <Col xs={12} md={2}>
                    <FloatingLabel label="Status *">
                      <Form.Select
                        name="status"
                        value={this.state.purchaseRequest.status}
                        required
                        disabled={this.state.purchaseRequest.id == undefined}
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        {this.state.currentPurchaseRequestStatus == -1 ? (
                          <option value={0}>Created</option>
                        ) : this.state.currentPurchaseRequestStatus == 0 ? (
                          <>
                            <option value={0}>New</option>
                            <option value={1}>Sent to Supplier</option>
                            <option value={4}>Cancelled</option>
                          </>
                        ) : this.state.currentPurchaseRequestStatus == 1 ? (
                          <>
                            <option value={1}>Sent to Supplier</option>
                            <option value={2}>Received</option>
                            <option value={3}>Partially Received</option>
                            <option value={4}>Cancelled</option>
                            <option value={5}>Rejected</option>
                          </>
                        ) : this.state.currentPurchaseRequestStatus == 2 ||
                          this.state.currentPurchaseRequestStatus == 3 ? (
                          <>
                            <option value={2}>Received</option>
                            <option value={3}>Partially Received</option>
                          </>
                        ) : this.state.currentPurchaseRequestStatus == 4 ? (
                          <option value={4}>Cancelled</option>
                        ) : this.state.currentPurchaseRequestStatus == 5 ? (
                          <option value={5}>Rejected</option>
                        ) : null}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>

                  <Col xs={12} md={2} className="text-center">
                    <Button
                      variant="warning"
                      className="mb-1 w-100"
                      size="sm"
                      disabled={this.state.purchaseRequest.id == undefined}
                      onClick={() => this.AddOrUpdatePurchaseRequestInDB(true)}
                    >
                      <FaRegFilePdf size={16} /> &nbsp;PDF/Print{" "}
                      <BsFillPrinterFill size={16} />
                    </Button>
                    {Number(this.state.purchaseRequest.status) === 0 && (
                      <Button
                        variant={
                          this.state.emailSent ? "outline-success" : "info"
                        }
                        size="sm"
                        className="ms-2 w-100"
                        disabled={!this.state.purchaseRequest.supplierId}
                        onClick={() => {
                          const supplier = (this.props.suppliers || []).find(
                            (s) => s.id == this.state.purchaseRequest.supplierId
                          );
                          const toEmail =
                            supplier?.emailId ||
                            prompt("Enter supplier email:");
                          if (toEmail) this.SendEmailToSupplier(toEmail);
                        }}
                      >
                        {this.state.emailSent
                          ? "Email Sent — Resend?"
                          : "Send Email to Supplier"}
                      </Button>
                    )}
                  </Col>
                </Row>

                <Row className="mt-2">
                  <Col>
                    <FloatingLabel label="Details (if any)">
                      <Form.Control
                        type="text"
                        size="sm"
                        id="description"
                        name="description"
                        maxLength="99"
                        value={this.state.purchaseRequest.description || ""}
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </FloatingLabel>
                  </Col>
                </Row>
                {/* Indent Items */}
                <Row className="mb-2">
                  <Col className="text-end">
                    <Button
                      disabled={this.props.status != 0}
                      size="sm"
                      variant="primary"
                      onClick={() => this.AddNewPurchaseItem()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="currentColor"
                        className="bi bi-plus-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.5.5 0 0 1 .5.5V7h2.5a.5.5 0 0 1 0 1H8.5v2.5a.5.5 0 0 1-1 0V8H5a.5.5 0 0 1 0-1h2.5V4.5A.5.5 0 0 1 8 4z" />
                      </svg>
                      &nbsp; Add Item
                    </Button>

                    {/* New: Add From Sales Order button */}
                    <Button
                      disabled={this.props.status != 0}
                      size="sm"
                      variant="secondary"
                      className="ms-2"
                      onClick={() => this.OpenSalesOrderModal()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="currentColor"
                        className="bi bi-card-list"
                        viewBox="0 0 16 16"
                      >
                        <path d="M14 4.5H2V3h12v1.5zM2 8h12V6.5H2V8zM2 12.5H14V11H2v1.5z" />
                      </svg>
                      &nbsp; Add From Sales Order
                    </Button>
                  </Col>
                </Row>

                <Table
                  bordered
                  size="sm"
                  className="text-start"
                  style={{ fontSize: "12px" }}
                >
                  <thead className="bg-secondary text-white text-center">
                    <tr className="align-middle">
                      <td width="3%"></td>
                      <td width="20%" className="text-start">
                        Item Name*
                      </td>

                      <td width="10%">Required (A) *</td>
                      <td width="10%">Received (B)</td>
                      <td width="10%">Pending (A-B)</td>
                      {window.innerWidth > 900 ? (
                        <>
                          <td width="10%">Unit*</td>
                        </>
                      ) : (
                        <></>
                      )}
                      <td width="10%">
                        Last P.Price*
                        <br />
                        (per unit)
                      </td>

                      <td width="10%">
                        Est.Tot
                        <br />
                        <h5 className="text-warning">
                          {Number(this.GetTotalEstimation()).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </h5>
                      </td>

                      <td width="5%"></td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.purchaseRequestItems &&
                    this.state.purchaseRequestItems.length
                      ? this.state.purchaseRequestItems.map((row, i) => (
                          <tr key={i} className="align-middle text-center">
                            <td>{i + 1}</td>
                            <td className="text-start">
                              <Form.Control
                                type="text"
                                name="itemName"
                                value={row.itemName}
                                required
                                disabled={this.props.status != 0}
                                onChange={(e) => this.handlesInputChange(e, i)}
                              />
                            </td>

                            <td>
                              <Form.Control
                                type="decimal"
                                name="qty"
                                value={row.qty}
                                disabled={this.props.status != 0}
                                required
                                min={0}
                                onChange={(e) => this.handlesInputChange(e, i)}
                              />
                            </td>

                            <td>
                              <Form.Control
                                type="decimal"
                                name="receivedQty"
                                value={row.receivedQty ?? 0}
                                disabled
                              />
                            </td>

                            <td>{row.qty ?? 0 - row.receivedQty ?? 0}</td>
                            {window.innerWidth > 900 ? (
                              <>
                                <td>
                                  <Form.Select
                                    name="unit"
                                    value={row.unit}
                                    required
                                    disabled={this.props.status != 0}
                                    onChange={(e) =>
                                      this.handlesInputChange(e, i)
                                    }
                                  >
                                    <option value={""}></option>
                                    <option value={"piece"}>piece</option>
                                    <option value={"gram"}>gram</option>
                                    <option value={"kg"}>kg</option>
                                    <option value={"ton"}>ton</option>
                                    <option value={"ml"}>ml</option>
                                    <option value={"liter"}>liter</option>
                                    <option value={"meter"}>meter</option>
                                  </Form.Select>
                                </td>
                              </>
                            ) : (
                              <></>
                            )}

                            <td className="text-end">
                              <Form.Control
                                type="decimal"
                                name="purchasePrice"
                                value={row.purchasePrice}
                                disabled={this.props.status != 0}
                                onChange={(e) => this.handlesInputChange(e, i)}
                              />
                            </td>

                            <td className="text-center">
                              {Number(
                                (row.purchasePrice || 0) * (row.qty || 0)
                              ).toLocaleString(
                                this.context.storeSettings.defaultLocale,
                                {
                                  minimumFractionDigits: 1,
                                  maximumFractionDigits: 1,
                                  style: "currency",
                                  currency:
                                    this.context.storeSettings.defaultCurrency,
                                }
                              )}
                            </td>

                            <td>
                              <OverlayTrigger
                                overlay={<Tooltip>Delete!</Tooltip>}
                              >
                                <Button
                                  variant="danger"
                                  size="sm"
                                  disabled={this.props.status != 0}
                                  onClick={() => this.handleRemoveClick(i)}
                                >
                                  X
                                </Button>
                              </OverlayTrigger>
                            </td>
                          </tr>
                        ))
                      : null}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer className="bg-light">
            <Form.Group>
              <Button variant="primary" size="lg" type="submit">
                Save
              </Button>
            </Form.Group>

            <Button variant="danger" size="lg" onClick={this.props.onHide}>
              Close
            </Button>
          </Modal.Footer>
        </Form>

        {/* Sales Order Modal */}
        <Modal
          show={this.state.showSalesOrderModal}
          onHide={() => this.setState({ showSalesOrderModal: false })}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Items from Sales Order</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-2">
              <Col md={8}>
                <Form.Select
                  size="sm"
                  value={this.state.selectedSalesOrderId || ""}
                  onChange={this.OnSalesOrderSelected}
                >
                  <option value="">-- Select Sales Order --</option>
                  {this.state.salesOrders.map((so) => (
                    <option key={so.id} value={so.id}>
                      {so.orderId || so.OrderId || so.id} &nbsp; | &nbsp;{" "}
                      {so.customerName || so.CustomerName}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col md={4} className="text-end">
                <Button
                  size="sm"
                  variant="info"
                  onClick={() => this.OpenSalesOrderModal()}
                >
                  Refresh
                </Button>
              </Col>
            </Row>

            <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
              <Table size="sm" bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Item Name</th>
                    <th>
                      {this.context.store.businessTypeId ==
                      this.context.BusinessTypes.STEELTRADERS
                        ? "Pieces"
                        : "Qty"}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.selectedSalesOrderItems &&
                  this.state.selectedSalesOrderItems.length ? (
                    this.state.selectedSalesOrderItems.map((it, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td className="text-start">{it.itemName}</td>
                        <td>{it.qty}</td>
                        {/* <td>{it.unit}</td>
                        <td className="text-end">{it.purchasePrice}</td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center">
                        {this.state.salesOrderLoading
                          ? "Loading..."
                          : "Select a Sales Order to see items"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showSalesOrderModal: false })}
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => this.AddSalesOrderItemsToRequest()}
            >
              Add All Items
            </Button>
          </Modal.Footer>
        </Modal>
      </Modal>
    );
  }
}
